export const getBarChartOptions = (title: string, barColor: string, categories: string[], isLightMode: boolean) => {
  return {
    chart: {
      zoom: {
        enabled: true
      },
      toolbar: {
        show: true
      },
      background: isLightMode ? '#fff' : '#383838'
    },
    title: {
      text: title,
      style: {
        fontSize: 16,
        fontColor: isLightMode ? '#1F2937' : '#dfdfdf'
      }
    },
    plotOptions: {
      bar: {}
    },
    colors: [barColor],
    dataLabels: {
      style: {
        colors: [isLightMode ? '#333' : '#dfdfdf']
      }
    },
    tooltip: {
      intersect: true
    },
    theme: {
      mode: isLightMode ? 'light' : 'dark'
    },
    xaxis: {
      categories: categories,
      labels: {
        show: true,
        style: {
          colors: [isLightMode ? '#1F2937' : '#dfdfdf'],
          fontSize: 14
        }
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: [isLightMode ? '#1F2937' : '#dfdfdf'],
          fontSize: 14
        }
      }
    }
  }
}
